import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'

import {useStyles} from '../SideBarStyles.js'
import IconExpandLess from '@material-ui/icons/ExpandLess'
import IconExpandMore from '@material-ui/icons/ExpandMore'
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import {Filters} from "../../../../utils/HelpFunctions";
import {useHistory} from "react-router-dom";

function Passengers(props) {

    const {permissions, DataStore} = props

    const gp = Filters(permissions, 'text', 'Gestión de pasajeros')
    const vpe = Filters(permissions, 'text', 'Validación de pagos express')

    let history = useHistory();

    const classes = useStyles()
    const [open, setOpen] = React.useState(false)

    function handleClick() {
        setOpen(!open)
    }

    return (
        <List component="nav" className={classes.appMenu} disablePadding>

            <ListItem button onClick={handleClick} className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                    <EmojiPeopleIcon/>
                </ListItemIcon>
                <ListItemText primary="Pasajeros" className={classes.menuItemText}/>
                {open ? <IconExpandLess className={classes.openSubMenuIcons}/> :
                    <IconExpandMore className={classes.openSubMenuIcons}/>}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Divider classes={{root: classes.divider}}/>
                <List>
                    {gp[0].value && <ListItem button className={classes.nested}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Gestión de pasajeros" className={classes.subItemsText}
                                      onClick={() => {
                                          history.push("/control-panel/passengers-managements")
                                          DataStore.getTabs('Gestión de pasajeros')
                                      }}/>
                    </ListItem>}
                    {vpe[0].value && <ListItem button className={classes.nested}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Validación  de pagos express" className={classes.subItemsText}
                                      onClick={() => {
                                          history.push("/control-panel/express-payment-validation")
                                          DataStore.getTabs('Validación  de pagos express')
                                      }}/>
                    </ListItem>}
                </List>
                <Divider classes={{root: classes.divider}}/>
            </Collapse>
        </List>
    )
}

export default Passengers
